export const UI = {
  de: {
    title: "Swiss Blockchain Alliance – Schweiz, ein Fundament für digitale Sicherheit",
    skip: "Zum Inhalt springen",
    newWindow: "(öffnet in neuem Fenster)",
    external: "(externe Seite)",
    langLabel: "Sprache wählen",
    header: {
      home: "Swiss Blockchain Alliance – Startseite",
      portal: "Kundenbereich",
      menuOpen: "Menü öffnen",
      menu: "Navigation",
      menuDesc: "Hauptnavigation der Website",
      mainNav: "Hauptnavigation",
      mobileNav: "Mobile Hauptnavigation",
      cta: "Aufgabe besprechen",
    },
    hero: {
      lines: ["Schweiz –", "ein Fundament für", "digitale Sicherheit"],
      sub: "Swiss Blockchain Alliance widmet sich dem Aufbau sicherer, widerstandsfähiger und konformer digitaler Infrastrukturen für Organisationen in risikoreichen und stark regulierten Umfeldern. Wir schliessen die Lücke zwischen Technologie, Sicherheitsbetrieb und Governance.",
      cta1: "Aufgabe besprechen",
      cta2: "Unsere Leistungen",
      graphic: "Schematische Darstellung einer geschützten digitalen Infrastruktur",
      nodes: ["IDENTITÄT", "CLOUD", "NETZWERK", "DATEN", "BETRIEB", "ZUGANG"],
    },
    services: {
      label: "Leistungen",
      title: "Wir schliessen die Lücke zwischen Technologie, Sicherheitsbetrieb und Governance.",
      photoAlt: "Glasfaser-Verbindungen in einem Rechenzentrum",
      band: "Technologie · Sicherheitsbetrieb · Governance",
    },
    groups: { label: "Arbeitsgruppen", title: "Arbeitsgruppen." },
    about: {
      label: "Über uns",
      title: "Swiss Blockchain Alliance.",
      verifyNote: "Die Angaben sind im Zentralen Firmenindex (Zefix) und im UID-Register des Bundes öffentlich einsehbar.",
    },
    pubs: {
      label: "Publikationen",
      title: "Unsere Publikationen.",
      read: "Beitrag lesen",
      back: "Alle Publikationen",
      more: "Weitere Beiträge",
      notFound: "Dieser Beitrag wurde nicht gefunden.",
      cta: "Fragen zu diesem Thema? Besprechen Sie Ihre Aufgabe mit uns.",
      ctaBtn: "Aufgabe besprechen",
    },
    member: {
      label: "Angebot & Mitgliedschaft",
      title: "Unser Angebot.",
      cta: "Mitgliedschaft anfragen",
    },
    contact: {
      label: "Kontakt",
      title: "Aufgabe besprechen.",
      intro: "Beschreiben Sie kurz Ihre Ausgangslage. Wir klären mit Ihnen, wo die Prioritäten liegen und welche nächsten Schritte sinnvoll sind.",
      address: "Adresse",
      email: "E-Mail",
      phone: "Telefon",
      clients: "Bestehende Kunden",
      toPortal: "Zum Kundenbereich",
      photoAlt: "Altstadt von Bern mit Zytglogge",
      photoCaption: "Bern · Schweiz",
    },
    form: {
      topics: { Leistungen: "Leistungen", Mitgliedschaft: "Mitgliedschaft", Kundenbereich: "Kundenbereich", Sonstiges: "Sonstiges" },
      err: {
        name: "Bitte geben Sie Ihren Namen an (mindestens 2 Zeichen).",
        phone: "Bitte geben Sie eine gültige Telefonnummer an (7 bis 15 Ziffern).",
        email: "Bitte geben Sie eine gültige E-Mail-Adresse an, z. B. name@firma.ch.",
        message: "Bitte beschreiben Sie Ihr Anliegen in mindestens 20 Zeichen.",
        consent: "Bitte bestätigen Sie, dass Sie die Datenschutzerklärung gelesen haben.",
      },
      unavailable: "Die Online-Übermittlung ist derzeit nicht verfügbar.",
      invalidData: "Einige Angaben konnten nicht verarbeitet werden.",
      failed: "Die Übermittlung ist fehlgeschlagen.",
      kept: "Ihre Eingaben bleiben erhalten.",
      altHint: "Senden Sie die Anfrage alternativ über Ihr E-Mail-Programm – der Text wird vorbereitet.",
      prepare: "E-Mail vorbereiten",
      successTitle: "Vielen Dank – Ihre Anfrage ist eingegangen.",
      successText: "Wir melden uns per E-Mail bei Ihnen.",
      ref: "Ihre Referenz:",
      another: "Weitere Anfrage senden",
      hint: "Alle Felder sind Pflichtfelder.",
      checkOne: "Bitte prüfen Sie das markierte Feld.",
      checkMany: (n) => `Bitte prüfen Sie die ${n} markierten Felder.`,
      required: "Pflichtfeld",
      optional: "optional",
      name: "Name",
      emailL: "E-Mail",
      org: "Organisation",
      phone: "Telefonnummer",
      topic: "Anliegen",
      message: "Ihre Aufgabe",
      placeholder: "Worum geht es? Welche Systeme oder Fragestellungen sind betroffen?",
      consentA: "Ich habe die ",
      consentLink: "Datenschutzerklärung",
      consentB: " gelesen und bin mit der Bearbeitung meiner Angaben zur Beantwortung der Anfrage einverstanden.",
      sending: "Wird gesendet …",
      submit: "Anfrage senden",
      mailto: "Stattdessen im E-Mail-Programm vorbereiten",
      mailSubject: "Anfrage",
      mailBodyPlaceholder: "[Bitte beschreiben Sie hier Ihr Anliegen]",
    },
    footer: {
      contact: "Kontakt",
      details: "Angaben",
      nav: "Navigation",
      legal: "Rechtliches",
      membership: "Mitgliedschaft",
      impressum: "Impressum",
      privacy: "Datenschutz",
      tagline: "Schweiz – ein Fundament für digitale Sicherheit.",
    },
    legal: { back: "Zur Startseite" },
    notFound: { title: "Seite nicht gefunden.", back: "Zur Startseite" },
  },
  en: {
    title: "Swiss Blockchain Alliance – Switzerland, a foundation for digital security",
    skip: "Skip to content",
    newWindow: "(opens in a new window)",
    external: "(external page)",
    langLabel: "Choose language",
    header: {
      home: "Swiss Blockchain Alliance – Home",
      portal: "Client area",
      menuOpen: "Open menu",
      menu: "Navigation",
      menuDesc: "Main website navigation",
      mainNav: "Main navigation",
      mobileNav: "Mobile main navigation",
      cta: "Discuss your task",
    },
    hero: {
      lines: ["Switzerland –", "a foundation for", "digital security"],
      sub: "Swiss Blockchain Alliance is dedicated to building secure, resilient, and compliant digital infrastructures for organizations in high-risk and highly regulated environments. We bridge the gap between technology, security operations, and governance.",
      cta1: "Discuss your task",
      cta2: "Our services",
      graphic: "Schematic illustration of a protected digital infrastructure",
      nodes: ["IDENTITY", "CLOUD", "NETWORK", "DATA", "OPERATIONS", "ACCESS"],
    },
    services: {
      label: "Services",
      title: "We bridge the gap between technology, security operations, and governance.",
      photoAlt: "Fibre-optic connections in a data centre",
      band: "Technology · Security operations · Governance",
    },
    groups: { label: "Working groups", title: "Working groups." },
    about: {
      label: "About",
      title: "Swiss Blockchain Alliance.",
      verifyNote: "These details are publicly available in the Central Business Name Index (Zefix) and the federal UID register.",
    },
    pubs: {
      label: "Publications",
      title: "Our publications.",
      read: "Read article",
      back: "All publications",
      more: "More articles",
      notFound: "This article could not be found.",
      cta: "Questions on this topic? Discuss your task with us.",
      ctaBtn: "Discuss your task",
    },
    member: {
      label: "Offer & Membership",
      title: "Our range.",
      cta: "Request membership",
    },
    contact: {
      label: "Contact",
      title: "Discuss your task.",
      intro: "Briefly describe your situation. Together we clarify where the priorities lie and which next steps make sense.",
      address: "Address",
      email: "Email",
      phone: "Phone",
      clients: "Existing clients",
      toPortal: "Go to client area",
      photoAlt: "Bern old town with the Zytglogge clock tower",
      photoCaption: "Bern · Switzerland",
    },
    form: {
      topics: { Leistungen: "Services", Mitgliedschaft: "Membership", Kundenbereich: "Client area", Sonstiges: "Other" },
      err: {
        name: "Please enter your name (at least 2 characters).",
        phone: "Please enter a valid phone number (7 to 15 digits).",
        email: "Please enter a valid email address, e.g. name@company.com.",
        message: "Please describe your request in at least 20 characters.",
        consent: "Please confirm that you have read the privacy policy.",
      },
      unavailable: "Online submission is currently unavailable.",
      invalidData: "Some details could not be processed.",
      failed: "Submission failed.",
      kept: "Your entries have been kept.",
      altHint: "Alternatively, send your request via your email app – the text will be prepared for you.",
      prepare: "Prepare email",
      successTitle: "Thank you – your request has been received.",
      successText: "We will get back to you by email.",
      ref: "Your reference:",
      another: "Send another request",
      hint: "All fields are required.",
      checkOne: "Please check the highlighted field.",
      checkMany: (n) => `Please check the ${n} highlighted fields.`,
      required: "Required",
      optional: "optional",
      name: "Name",
      emailL: "Email",
      org: "Organisation",
      phone: "Phone number",
      topic: "Topic",
      message: "Your task",
      placeholder: "What is it about? Which systems or questions are affected?",
      consentA: "I have read the ",
      consentLink: "privacy policy",
      consentB: " and agree to my details being processed to answer my request.",
      sending: "Sending …",
      submit: "Send request",
      mailto: "Prepare in your email app instead",
      mailSubject: "Request",
      mailBodyPlaceholder: "[Please describe your request here]",
    },
    footer: {
      contact: "Contact",
      details: "Details",
      nav: "Navigation",
      legal: "Legal",
      membership: "Membership",
      impressum: "Legal notice",
      privacy: "Privacy policy",
      tagline: "Switzerland – a foundation for digital security.",
    },
    legal: { back: "Back to home" },
    notFound: { title: "Page not found.", back: "Back to home" },
  },
};
